<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col v-if="notFound" xl="12" lg="12" sm="12" class="text-danger mb-2">
                            <div class="bg-gray pt-2 pb-2 pl-3">
                                <span>{{ (currentLocale === 'bn') ? "প্রার্থীর তথ্য পাওয়া যায়নি । দয়া করে আবার অনুসন্ধান করুন ভেলিড “রেজিস্ট্রেশন নম্বর” ব্যবহার করে!" : "Applicant's data not found. Please search again using valid 'Registration Number'!" }}</span>
                            </div>
                        </b-col>
                        <b-col xl="12" lg="12" sm="12">
                            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset" enctype="multipart/form-data">
                                    <b-overlay :show="unitLoad">
                                        <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                                <ValidationProvider name="Registration Id" vid="registration_id" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="registration_id"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('rehabilitation_management.registration_id')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                        id="registration_id"
                                                        v-model="rehabInformation.registration_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="6">
                                                <ValidationProvider name="Organization Name" vid="organization_name" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="organization_name"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('rehabilitation_management.organization_name')}}
                                                </template>
                                                <b-form-input readonly
                                                    id="organization_name"
                                                    v-model="rehabInformation.org_name"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="6">
                                                <ValidationProvider name="Institute Type" vid="institute_type" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="institute_type"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('child_admission_management.institute_type')}}
                                                </template>
                                                <b-form-input readonly
                                                    id="institute_type"
                                                    v-model="rehabInformation.institute_type"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="6">
                                                <ValidationProvider name="Institute Name" vid="institute_name" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="institute_name"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                <template v-slot:label>
                                                    {{$t('child_admission_management.institute_name')}}
                                                </template>
                                                <b-form-input readonly
                                                    id="institute_name"
                                                    v-model="rehabInformation.institute_name"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                                <ValidationProvider name="Applicant's Name" vid="applicant_name" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="applicant_name"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('rehabilitation_management.applicant_name')}}
                                                    </template>
                                                    <b-form-input
                                                        readonly
                                                        id="applicant_name"
                                                        v-model="rehabInformation.applicant_name"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                                <ValidationProvider name="Contact No" vid="contact_no" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="contact_no"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                            {{$t('rehabilitation_management.contact_no')}}
                                                        </template>
                                                        <b-form-input
                                                            readonly
                                                            id="contact_no"
                                                            v-model="rehabInformation.contact_no"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                                            ></b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                                <ValidationProvider name="Date" vid="date" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="date"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('globalTrans.date')}}<span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                        class="date-picker"
                                                        v-model="rehabInformation.date"
                                                        :placeholder="$t('globalTrans.date')"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                              <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="Rehabilitation Type" vid="rehabilitation_type_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="rehabilitation_type_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('child_configuration.rehabilitation_type')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="rehabInformation.rehabilitation_type_id"
                                                    :options="getRehabilitationTypeList"
                                                    id="rehabilitation_type_id"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ "Committee Type is Mandatory" }}
                                                    </div>
                                                </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col xl="6" lg="6" sm="12" v-if="rehabInformation.rehabilitation_type_id === 4">
                                                <ValidationProvider name="Rehabilitation to (En)" vid="rehabilitation_to" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="rehabilitation_to"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('rehabilitation_management.rehabilitation_to_en')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                        id="rehabilitation_to"
                                                        v-model="rehabInformation.rehabilitation_to"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12" v-if="rehabInformation.rehabilitation_type_id === 4">
                                                <ValidationProvider name="Rehabilitation to (Bn)" vid="rehabilitation_to_bn" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="rehabilitation_to_bn"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('rehabilitation_management.rehabilitation_to_bn')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                        id="rehabilitation_to_bn"
                                                        v-model="rehabInformation.rehabilitation_to_bn"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Area Type" vid="area_type_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="area_type_id "
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{$t('org_pro.area_type')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                            plain
                                                            v-model="rehabInformation.area_type_id"
                                                            id="area_type_id"
                                                            :options="getAreaTypeList"
                                                            @change="getAreaTypeData(rehabInformation.area_type_id)"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="division_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{ $t('org_pro_division.division')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="rehabInformation.division_id"
                                                        :options="divisionList"
                                                        id="division_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="district_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{ $t('org_pro_district.district')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="rehabInformation.district_id"
                                                        :options="districtList"
                                                        id="district_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12" v-if="PauroshobaItemShow || UnionItemShow">
                                                <ValidationProvider name="Upazila" vid="upazila_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="upazila_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{ $t('org_pro_upazilla.upazilla')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="rehabInformation.upazila_id"
                                                        :options="upazilaList"
                                                        id="upazila_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12" v-if="UnionItemShow">
                                                <ValidationProvider name="Union" vid="union_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="union_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{ $t('org_pro_union.union')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="rehabInformation.union_id"
                                                        :options="unionList"
                                                        id="union_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12" v-if="CityCorpItemShow">
                                                <ValidationProvider name="City Corporation" vid="city_corporation_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="city_corporation_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('org_pro.city_corporation') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="rehabInformation.city_corporation_id"
                                                        :options="cityCorporationList"
                                                        id="city_corporation_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12" v-if="PauroshobaItemShow">
                                                <ValidationProvider name="Pourosoba" vid="paurasabha_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="paurasabha_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('educational_management.pourosoba') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="rehabInformation.paurasabha_id"
                                                        :options="pauroshobaList"
                                                        id="paurasabha_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12" v-if="ItemShow">
                                                <ValidationProvider name="Ward" vid="ward_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="ward_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('org_pro.ward') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="rehabInformation.ward_id"
                                                        :options="wardList"
                                                        id="ward_id"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <b-row v-if="ItemShow">
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Address(En)" vid="address">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="address"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('child_admission_management.address_en')}}
                                                    </template>
                                                        <b-form-textarea
                                                        id="address"
                                                        v-model="rehabInformation.address"
                                                        rows="1"
                                                        max-rows="2"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-textarea>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Address(Bn)" vid="address_bn">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="address_bn"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('child_admission_management.address_bn')}}
                                                    </template>
                                                        <b-form-textarea
                                                        id="address_bn"
                                                        v-model="rehabInformation.address_bn"
                                                        rows="1"
                                                        max-rows="2"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-textarea>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col xl="6" lg="6" sm="12">
                                                <ValidationProvider name="Remarks (En)" vid="remarks">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="remarks"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('legal_institute_management.remarks_en')}}
                                                    </template>
                                                    <b-form-textarea
                                                        id="remarks"
                                                        v-model="rehabInformation.remarks"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-textarea>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xl="6" lg="6" sm="12">
                                                <ValidationProvider name="Remarks (Bn)" vid="remarks_bn">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="remarks_bn"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        {{$t('legal_institute_management.remarks_bn')}}
                                                    </template>
                                                    <b-form-textarea
                                                        id="remarks_bn"
                                                        v-model="rehabInformation.remarks_bn"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-textarea>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                    </b-overlay>
                                    <div class="row">
                                        <div class="col-sm-3"></div>
                                        <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                        </div>
                                    </div>
                                </b-form>
                            </ValidationObserver>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { rehabilitationInfoStoreApi, rehabilitationInfoUpdateApi, applicantDataByRegApi } from '../../api/routes'
import flatpickr from 'flatpickr'
import Custom from '../../../../../store/custom'
import { isNotEmpty } from '@amcharts/amcharts4/.internal/core/utils/Utils'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            notFound: false,
            unitLoad: false,
            ItemShow: false,
            CityCorpItemShow: false,
            PauroshobaItemShow: false,
            UnionItemShow: false,
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            rehabInformation: {
                online_admission_id: 0,
                registration_id: '',
                org_name: '',
                institute_type: '',
                institute_name: '',
                applicant_name: '',
                contact_no: '',
                rehabilitation_type_id: 0,
                rehabilitation_to: '',
                rehabilitation_to_bn: '',
                area_type_id: 0,
                city_corporation_id: 0,
                paurasabha_id: 0,
                ward_id: 0,
                division_id: 0,
                district_id: 0,
                upazila_id: 0,
                union_id: 0,
                address: '',
                address_bn: '',
                date: '',
                remarks: '',
                remarks_bn: ''
            },
            rehabilitationTypeList: [],
            districtList: [],
            upazilaList: [],
            unionList: [],
            cityCorporationList: [],
            pauroshobaList: [],
            wardList: []
        }
    },
    created () {
        if (this.id) {
            const tmp = this.getRehabInformation()
            this.rehabInformation = tmp
            this.getAreaTypeData(this.rehabInformation.area_type_id)
        }
    },
    mounted () {
        flatpickr('.date-picker', {})
        core.index()
    },
    computed: {
    //      getRehabilitationTypeList: function () {
    //   return this.productCommonObj.rehabilitationTypeList.filter(item => item.status === 1)
    // },
    // ...mapGetters({
    //   productCommonObj: 'ChildService/commonObj'
    // }),
        getAreaTypeList: function () {
            const objectData = Custom.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.id, text: obj.name_bn }
                } else {
                    return { value: obj.id, text: obj.name }
                }
            })
        },
        getRehabilitationTypeList: function () {
            return this.$store.state.ChildService.commonObj.rehabilitationTypeList.filter(item => item.status === 1)
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        currentLocale () {
            return this.$i18n.locale
        }
    },
    watch: {
        'rehabInformation.registration_id': function (newVal, oldVal) {
            this.notFound = false
            this.rehabInformation.applicant_name = ''
            this.rehabInformation.org_name = ''
            this.rehabInformation.institute_type = ''
            this.rehabInformation.institute_name = ''
            this.rehabInformation.contact_no = ''
            if (newVal !== oldVal) {
                if (newVal.length === 11) {
                    this.loadApplicantData(newVal)
                }
            }
        },
        'rehabInformation.division_id': function (newVal, oldVal) {
            this.districtList = this.getDistrictList(newVal)
        },
        'rehabInformation.district_id': function (newVal, oldVal) {
            this.cityCorporationList = this.getCityCorporationList(newVal)
            this.upazilaList = this.getUpazilaList(newVal)
        },
        'rehabInformation.upazila_id': function (newVal, oldVal) {
            this.unionList = this.getUnionList(newVal)
            this.pauroshobaList = this.getPauroshobaList(newVal)
        },
        'rehabInformation.city_corporation_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByCityCorportaion(newVal)
        },
        'rehabInformation.paurasabha_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByPauroshoba(newVal)
        },
        'rehabInformation.union_id': function (newVal, oldVal) {
            this.wardList = this.getWardListByUnion(newVal)
        }
    },
    methods: {
        loadApplicantData (regNo) {
            this.unitLoad = true
            const search = {
                registration_id: regNo,
                is_resident: 1
            }
            RestApi.getData(childServiceBaseUrl, applicantDataByRegApi, search).then(response => {
                if (response.success) {
                    if (isNotEmpty(response.data)) {
                        this.rehabInformation.online_admission_id = response.data.id
                        this.rehabInformation.applicant_name = this.$i18n.locale === 'bn' ? response.data.name_bn : response.data.name
                        this.rehabInformation.org_name = this.getOrgName(response.data.org_id)
                        this.rehabInformation.institute_type = this.getInstituteType(response.data.office_type_id)
                        this.rehabInformation.institute_name = this.getInstituteName(response.data.office_id)
                        this.rehabInformation.contact_no = response.data.contact_no
                        this.notFound = false
                        this.unitLoad = false
                    } else {
                        this.notFound = true
                        this.unitLoad = false
                    }
                }
            })
        },
        getAreaTypeData (typeId) {
            this.ItemShow = true
            if (typeId === 1) {
                this.ItemShow = true
                this.CityCorpItemShow = true
                this.PauroshobaItemShow = false
                this.UnionItemShow = false
            } else if (typeId === 2) {
                this.ItemShow = true
                this.CityCorpItemShow = false
                this.PauroshobaItemShow = true
                this.UnionItemShow = false
            } else if (typeId === 3) {
                this.ItemShow = true
                this.CityCorpItemShow = false
                this.PauroshobaItemShow = false
                this.UnionItemShow = true
            }
        },
         getDistrictList (divisionId = null) {
            const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)
            if (divisionId) {
                return districtList.filter(district => district.division_id === divisionId)
            }
            return districtList
        },
        getUpazilaList (districtId = null) {
            const UpaZila = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)
            if (districtId) {
                return UpaZila.filter(upazila => upazila.district_id === districtId)
            }
            return UpaZila
        },
        getUnionList (upazilaId) {
            const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
            if (upazilaId) {
                return unionList.filter(union => union.upazilla_id === upazilaId)
            }
            return unionList
        },
        getCityCorporationList (districtId) {
            const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getPauroshobaList (upazillaId = null) {
            const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
            if (upazillaId) {
                return objectData.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        return { value: obj.value, text: obj.text_en }
                    }
                })
            }
        },
        getWardListByCityCorportaion (cityCorpId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getWardListByPauroshoba (pauroshobaId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getWardListByUnion (unionId) {
            const objectData = this.$store.state.commonObj.wardList
            const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
            return wardObjectList.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text }
                }
            })
        },
        getOrgName (orgId) {
            const tmpData = this.$store.state.commonObj.organizationProfileList.find(item => item.value === orgId && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteType (Id) {
            const tmpData = this.$store.state.commonObj.officeTypeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getInstituteName (Id) {
            const tmpData = this.$store.state.commonObj.officeList.find(item => item.value === Id && item.status === 0)
            if (this.$i18n.locale === 'bn') {
                return tmpData.text_bn
            } else {
                return tmpData.text_en
            }
        },
        getRehabInformation () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        async storeUpdate () {
            this.unitLoad = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            if (this.id) {
                result = await RestApi.putData(childServiceBaseUrl, `${rehabilitationInfoUpdateApi}/${this.id}`, this.rehabInformation)
            } else {
                result = await RestApi.postData(childServiceBaseUrl, rehabilitationInfoStoreApi, this.rehabInformation)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.unitLoad = false
                this.$bvModal.hide('modal-4')
            } else {
                this.unitLoad = false
                this.$toast.error({
                    title: this.$t('globalTrans.error'),
                    message: result.message,
                    color: '#D6E09B'
                })
                this.$refs.form.setErrors(result.errors)
            }
        }
    }
}

</script>
